import classNames from "classnames";
import InputMask from "react-input-mask";
import MoneyInput from "./MoneyInput";

export const TextBlock = ({
  label,
  value,
  onChange,
  error,
  optional,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  optional?: boolean;
}) => (
  <div className="flex flex-col gap-1">
    <label className="text-sm font-bold">{label}</label>
    <input
      className={classNames("border rounded py-2 px-3", {
        "border-red-700 bg-red-50": error,
      })}
      type="text"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      required={!optional}
    />
  </div>
);

export const PasswordBlock = ({
  label,
  value,
  onChange,
  error,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
}) => (
  <div className="flex flex-col gap-1">
    <label className="text-sm font-bold">{label}</label>
    <input
      className={classNames("border rounded py-2 px-3", {
        "border-red-700 bg-red-50": error,
      })}
      type="password"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      required
    />
  </div>
);

export const EmailBlock = ({
  label,
  value,
  onChange,
  error,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
}) => (
  <div className="flex flex-col gap-1">
    <label className="text-sm font-bold">{label}</label>
    <input
      className={classNames("border rounded py-2 px-3", {
        "border-red-700 bg-red-50": error,
      })}
      type="email"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      required
    />
  </div>
);

export const MoneyBlock = ({
  label,
  value,
  onChange,
  error,
  autoFocus,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  autoFocus?: boolean;
}) => {
  return (
    <div className="flex flex-col gap-1">
      <label className="text-sm font-bold">{label}</label>
      <MoneyInput
        className={classNames("border rounded py-2 px-3", {
          "border-red-700 bg-red-50": error,
        })}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
      />
    </div>
  );
};

export const SelectBlock = ({
  label,
  value,
  onChange,
  options,
  disabled,
  error,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: string }[];
  disabled?: boolean;
  error?: boolean;
}) => (
  <div className="flex flex-col gap-1">
    <label className="text-sm font-bold">{label}</label>
    <select
      className={classNames("border rounded py-2 px-3", {
        "border-red-700 bg-red-50": error,
        "bg-gray-100": disabled,
      })}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      disabled={disabled}
      required
    >
      <option></option>
      {options.map(({ value, label }) => (
        <option value={value} key={value}>
          {label}
        </option>
      ))}
    </select>
  </div>
);

export const CheckboxItem = ({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <label className="flex gap-2 items-center">
    <input
      type="checkbox"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
    />
    <span>{label}</span>
  </label>
);

export const MaskedTextBlock = ({
  label,
  value,
  placeholder,
  onChange,
  mask,
  error,
  optional,
  className,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  mask: string;
  placeholder?: string;
  error?: boolean;
  optional?: boolean;
  className?: string;
}) => (
  <div className={`flex flex-col gap-1 ${className}`}>
    <label className="text-sm font-bold">{label}</label>
    <InputMask
      className={classNames("border rounded py-2 px-3 w-full", {
        "border-red-700 bg-red-50": error,
      })}
      mask={mask}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      required={!optional}
      placeholder={placeholder}
    />
  </div>
);

export const TextAreaBlock = ({
  label,
  value,
  onChange,
  rows = 3,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  rows?: number;
}) => (
  <div className={`flex flex-col gap-1`}>
    <label className="text-sm font-bold">{label}</label>
    <textarea
      className="border rounded py-1 px-3 w-full"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      rows={rows}
      required
    />
  </div>
);
